import React, { useState } from 'react';
import LeadModal from './LeadModal';
import './Hero.css';

const Hero = () => {
  const [isLeadModalOpen, setIsLeadModalOpen] = useState(false);

  return (
    <section id="hero" className="hero">
      <div className="hero-bg">
        <img src="/images/hero-bg.webp" alt="" className="hero-bg-img" />
      </div>
      <div className="hero-content">
        <h1 className="hero-title">
          Производство шкафов из нержавеющей стали AISI 304/316
        </h1>
        <p className="hero-subtitle">
          Разработка по чертежам, сборка, доработка — от 10 дней. Гарантия 5 лет в агрессивных средах.
        </p>
        <div className="hero-buttons">
          <button type="button" className="hero-btn-primary" onClick={() => setIsLeadModalOpen(true)}>
            Получить КП
          </button>
        </div>
      </div>
      <LeadModal show={isLeadModalOpen} onClose={() => setIsLeadModalOpen(false)} goalId="form-kp" />
    </section>
  );
};

export default Hero;
